import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=12a26f86&"
import script from "./FormTask.vue?vue&type=script&lang=js&"
export * from "./FormTask.vue?vue&type=script&lang=js&"
import style0 from "./FormTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports